//展示公司列表
import { Table, Breadcrumb, Space, Button, Modal, Form, Input, Select } from "antd"

import { useSearchParams } from 'react-router-dom';
import { useState, useEffect } from "react"
import { useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import { useDepartmentList } from "@/hooks/useDepartmentList";
import FormItem from "antd/es/form/FormItem";

import { getDepartmentAPI } from '@/apis/department'

const DepartmentDisplay = () => {
    const [searchParams] = useSearchParams()
    const companyId = parseInt(searchParams.get('id'))

    const { t } = useTranslation();
    const colums = [
        {
            title: '部门名称',
            dataIndex: 'departmentName',
            key: 'departmentName',
        },
        {
            title: '部门人数',
            dataIndex: 'memberAccount',
            key: 'memberAccount',
        },
        {
            title: '公司名称',
            dataIndex: 'companyName',
            key: 'companyName',
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
        },
        {
            title: '更新时间',
            dataIndex: 'updateTime',
            key: 'updateTime',
        },
        {
            title: t('FormList.Action'),
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button onClick={() => toDepartmentDetail(record.id)} type="primary">
                        {t('ButtonList.Check')}
                    </Button>
                    <Button onClick={() => ShowModal(record.id)}>
                        {t('ButtonList.Update')}
                    </Button>
                    <Button type="primary" danger>
                        {t('ButtonList.Delete')}
                    </Button>
                </Space>
            )
        },
    ]

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showDepartmentId, setShowDepartmentId] = useState(1);
    const [departmentData, setDepartmentData] = useState({})
    const { departmentList } = useDepartmentList(companyId)

    // const handleChange = (value) => {
    //   console.log(`selected ${value}`);
    // };

    const ShowModal = (id) => {
        setShowDepartmentId(id)
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    useEffect(() => {
        const getDepartmentData = async () => {
            const res = await getDepartmentAPI(showDepartmentId)
            const resData = await res.data
            setDepartmentData(resData)
        }
        getDepartmentData(showDepartmentId)
    }, [showDepartmentId])

    const navigate = useNavigate()
    const toDepartmentDetail = (id) => {
        navigate(`/DepartmentDetail?id=${id}`)
    }
    const toCompanyDetail = (id) => {
        navigate(`/CompanyDetail?id=${id}`)
    }

    return (
        <div>

            <Table dataSource={departmentList} columns={colums} rowKey={(record) => record.id} />
            <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <Form
                    labelCol={{
                        span: 8,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    style={{
                        marginTop: 20,
                        maxWidth: 600,
                    }}
                >
                    <FormItem name="departmentName" label="departmentName">
                        <Input placeholder={departmentData.departmentName} />
                    </FormItem>
                </Form>
            </Modal>
        </div>
    )
}

export default DepartmentDisplay